import LedgerPage from '../../pages/LedgerPage';
import { useCashierStream } from '../CashierLayout';

/**
 * 收银端账本（`05-ui-design-system.md` §3.3 的 `/cashier/ledger`，归 Phase 9 接线）。
 *
 * ## **不新建组件**：直接复用社团后台的账本页（`pages/LedgerPage.tsx`，即 §3.3 的 R2 `OrderLedger`）
 *
 * 两者是**同一个组件、同一份数据**（§3.3 那一行的原话）。复制一份的代价不是「多几个文件」：
 * `LedgerPage` 里握着 CSV 的列定义（11 列的表头）、导出通道、退款口径与「售出库存」的聚合口径 ——
 * 抄一份之后它们会各自演化，而漂移的症状是**导出的账目对不上**（A-P7-13 登记过的那一类）。
 * 因此这里只做**两个 prop 都不需要**的接线：地点门 + 页根锚点。
 *
 * ## 地点门
 *
 * 收银端的地点来自布局的流上下文（`useCashierStream().locationId`），**订阅**它而不是
 * 挂载时快照 `readCashierLocationId()`：冷启动深链 `/cashier/ledger?locationId=<uuid>` 时
 * 本页先挂载、布局的 `GET /locations` 后回来 —— 快照写法会永远停在「请先选择地点」
 * （Task 24 验收缺陷 3 的同一个坑，扫码页与订单页各踩过一次）。
 *
 * `请先选择地点` 是 §3.3 表里逐字给出的空态（出处 `admin/Ledger.tsx:124`）。
 *
 * ⚠️ **如实登记的边界**：计划 Task 9 Step 5 的片段写的是 `<OrderLedger locationId={locationId} />`，
 * 而 Phase 6 落地的账本页**没有** `locationId` 这个 prop（它自己的「地点」下拉默认是「全部地点」）。
 * 把 `locationId` 透传进去需要改 `apps/tenant/src/pages/LedgerPage.tsx` —— 那在本任务的落点
 * （`apps/tenant/src/cashier/**`）之外，且会让「同一个组件」多出一条只有收银端用的分支。
 * ⇒ 本任务**不改它**：收银端账本用的就是社团后台那一份（含它自己的地点筛选），
 * 地点门只决定「一个地点都没选时不许看账本」。这条张力写进交付报告，不在这里偷偷绕开。
 */
export default function CashierLedgerPage() {
  const { locationId } = useCashierStream();
  if (locationId === null) return <p className="py-12 text-center text-gray-500">请先选择地点</p>;

  return (
    <section data-testid="cashier-ledger-page">
      <LedgerPage />
    </section>
  );
}
